import React from "react";
import FlagIconFactory from "react-flag-icon-css";

const FlagIcon = FlagIconFactory(React, { useCssModules: false });

const CountryTableCell = props => {
  return (
    <React.Fragment>
      <FlagIcon code={props.code} />
      <span className="country-name">
        {props.name}
      </span>
    </React.Fragment>
  );
};

export default CountryTableCell;
